import * as React from 'react';
import { observer } from 'mobx-react';
import styles from './index.less';
import LinkC from '@src/components/link';
import cx from 'classnames';
import { Link } from 'react-scroll';
import $$tracker from '@src/tracker';

/**
 * 移动端游戏顶部导航
 * 如果需要跳转到具体的节点, 需要在需要跳转的部分, 加入
 * <Element name="menuListId" className="new-classic-appointment-part" />
 * menuListId - 对应的节点id, 匹配menuList中的id值
 * @param store
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */

const TopMenu = ({ store, onOrderClick, indexWebUrl, ...rest }) => {
  store.use();
  const { mainStore } = store;

  /** 预约按钮 */
  const reservationBtnRender = () => {
    if (['appointment', 'pre_download'].includes(mainStore?.game_stage_config)) {
      const className = cx('main-layer-174', { end: mainStore?.projectConfig?.phone });
      return <LinkC className={className} onClick={store?.onReservation} data-name="立即预约" />;
    }
    return null;
  };
  return (
    <div className={styles.root}>
      <div className="main-group-55" data-name="顶栏">
        <div className="main-layer-173" />
        <div className="main-group-56" data-name="右边">
          {reservationBtnRender()}
          <LinkC className="btn-website" href={indexWebUrl} onClick={$$tracker.clickGuanwang} data-name="进入官网" />
          <LinkC className="main-layer-175" onClick={store.onchangeMenu} data-name="菜单" />
        </div>

        <div className="main-group-57" data-name="左边">
          <div className="main-layer-176" />
          <div className="main-layer-177" />
        </div>
      </div>
      {/* this.mainStore */}
      {store.menuState && (
        <div className="main-group-58" data-name=" H5导航二">
          <div className="main-layer-178" />
          <div className="main-group-59" data-name="导航列表">
            <div className="nav-item">
              <Link className="main-layer-179" onClick={store.onchangeMenu} to={'kv'} spy={true} offset={-60} smooth={true} duration={200} />
            </div>
            <div className="nav-item">
              <Link className="main-layer-180" onClick={store.onchangeMenu} to={'activity'} spy={true} offset={-40} smooth={true} duration={200} />
            </div>
            <div className="nav-item">
              <Link className="main-layer-181" onClick={store.onchangeMenu} to={'feature'} spy={true} offset={-20} smooth={true} duration={200} />
            </div>
            <div className="nav-item">
              <Link className="main-layer-182" onClick={store.onchangeMenu} to={'sect'} spy={true} offset={-60} smooth={true} duration={200} />
            </div>
            <div className="nav-item">
              <Link className="main-layer-183" onClick={store.onchangeMenu} to={'channel'} spy={true} smooth={true} duration={200} />
            </div>
          </div>
          <div className="main-group-62" data-name="logo组">
            <div className="main-layer-191" />
            <div className="main-layer-192" />
            <div className="main-layer-193" />
          </div>

          <LinkC className="main-layer-194" onClick={store.onchangeMenu} />
        </div>
      )}

      {/*<div className={cx(styles.menuContent, store.menuState ? styles.menuAct : '')} data-name="下拉导航">*/}
      {/*  <div className={styles.menuTabList}>*/}
      {/*    {store.menuList?.map(tab => {*/}
      {/*      return (*/}
      {/*        <Link*/}
      {/*          key={`topMenu-${tab.id}`}*/}
      {/*          className={cx(styles.topMenuText)}*/}
      {/*          onClick={() => {*/}
      {/*            store.onClickRightNav(tab.name);*/}
      {/*            store.onchangeMenu(!store.menuState);*/}
      {/*          }}*/}
      {/*          to={tab.id}*/}
      {/*          spy={true}*/}
      {/*          smooth={true}*/}
      {/*          duration={200}*/}
      {/*        >*/}
      {/*          {tab.name}*/}
      {/*        </Link>*/}
      {/*      );*/}
      {/*    })}*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default observer(TopMenu);
